export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9920.79ba5b1b.jpg";